var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", _vm._g({ staticClass: "swatches" }, _vm.$listeners), [
    _vm.$mq !== "mobile" && _vm.$mq !== "tablet"
      ? _c(
          "div",
          { staticClass: "swatches__simple" },
          _vm._l(_vm.variants.slice(0, 6), function(variant, index) {
            return _c(
              "button",
              {
                key: "swatch_" + variant.id,
                staticClass: "swatches__swatch",
                class: {
                  "swatches__swatch--active": variant.id === _vm.value.id
                },
                attrs: {
                  "aria-controls": _vm.ariaControls,
                  "aria-label": variant[_vm.optionKey],
                  title: variant[_vm.optionKey],
                  tabindex: "0"
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "enter",
                        13,
                        $event.key,
                        "Enter"
                      ) &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar"
                      ])
                    ) {
                      return null
                    }
                    $event.stopPropagation()
                    return _vm.$emit("input", variant)
                  },
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.$emit("input", variant)
                  }
                }
              },
              [
                !_vm.showDefault[index] && variant.swatch_image
                  ? _c("img", {
                      attrs: {
                        src: variant.swatch_image,
                        alt: variant[_vm.optionKey]
                      },
                      on: {
                        error: function($event) {
                          return _vm.$set(_vm.showDefault, index, true)
                        }
                      }
                    })
                  : !_vm.showDefault[index]
                  ? _c("img", {
                      attrs: {
                        src: _vm.fileUrl(
                          "swatch_" +
                            _vm.normalize(variant[_vm.optionKey]) +
                            ".png"
                        ),
                        alt: variant[_vm.optionKey]
                      },
                      on: {
                        error: function($event) {
                          return _vm.$set(_vm.showDefault, index, true)
                        }
                      }
                    })
                  : _c("img", {
                      attrs: {
                        src: _vm.fileUrl("swatch_default_color.png"),
                        alt: variant[_vm.optionKey]
                      }
                    })
              ]
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "swatches__simple" },
          _vm._l(_vm.variants.slice(0, 4), function(variant, index) {
            return _c(
              "button",
              {
                key: "swatch_" + variant.id,
                staticClass: "swatches__swatch",
                class: {
                  "swatches__swatch--active": variant.id === _vm.value.id
                },
                attrs: {
                  "aria-controls": _vm.ariaControls,
                  "aria-label": variant[_vm.optionKey],
                  title: variant[_vm.optionKey],
                  tabindex: "0"
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "enter",
                        13,
                        $event.key,
                        "Enter"
                      ) &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar"
                      ])
                    ) {
                      return null
                    }
                    $event.stopPropagation()
                    return _vm.$emit("input", variant)
                  },
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.$emit("input", variant)
                  }
                }
              },
              [
                !_vm.showDefault[index] && variant.swatch_image
                  ? _c("img", {
                      attrs: {
                        src: variant.swatch_image,
                        alt: variant[_vm.optionKey]
                      },
                      on: {
                        error: function($event) {
                          return _vm.$set(_vm.showDefault, index, true)
                        }
                      }
                    })
                  : !_vm.showDefault[index]
                  ? _c("img", {
                      attrs: {
                        src: _vm.fileUrl(
                          "swatch_" +
                            _vm.normalize(variant[_vm.optionKey]) +
                            ".png"
                        ),
                        alt: variant[_vm.optionKey]
                      },
                      on: {
                        error: function($event) {
                          return _vm.$set(_vm.showDefault, index, true)
                        }
                      }
                    })
                  : _c("img", {
                      attrs: {
                        src: _vm.fileUrl("swatch_default_color.png"),
                        alt: variant[_vm.optionKey]
                      }
                    })
              ]
            )
          }),
          0
        ),
    _vm.variants.length > 6 && _vm.$mq !== "mobile" && _vm.$mq !== "tablet"
      ? _c("span", { staticClass: "swatches__more-count" }, [
          _vm._v("+" + _vm._s(_vm.variants.length - 6))
        ])
      : _vm._e(),
    _vm.variants.length > 4 && (_vm.$mq === "mobile" || _vm.$mq === "tablet")
      ? _c("span", { staticClass: "swatches__more-count" }, [
          _vm._v("+" + _vm._s(_vm.variants.length - 4))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }